import Vue from 'vue';
import VueRouter from 'vue-router'
import DashboardMain from "@/pages/dashboard/DashboardMain";
import Stats from "@/pages/dashboard/stats/Stats";
// import routes file
// import Error404 from "../../views/error-pages/Error404.vue";
import routesRegistration from './routes-registration/routes-registration'
import AuthMain from "@/pages/auth/AuthMain";
import Login from '@/pages/auth/Login'
import VerifyOtp from '@/pages/auth/VerifyOtp'
Vue.use(VueRouter);

const routes = [
    {
        path: '/auth',
        component: AuthMain,
        children: [
            {
                name: 'login',
                path: 'login',
                component: Login,
            },
            {
                name: 'verify-otp',
                path: 'verify-otp',
                component: VerifyOtp
            },

        ],
    },
    // { path: '/', redirect: { name: 'index' } },
    {
        name: 'dashboard',
        path: '/app',
        component: DashboardMain,
        children: [{
                // name: 'index',
                name: 'overview',
                path: '/app',
            meta:{
                activeTabKey:'overview'
            },
                component: Stats,
            },
            /* Add routes */
            ...routesRegistration
        ],
    },
    // {
    //     name: 'Error-404',
    //     path: 'Error-404',
    //     component: Error404
    // },
    // { path: '*', redirect: { name: 'Error-404' } },


]

const router = new VueRouter({
    mode: 'history',
    routes // short for `routes: routes`
})

export default router;
